import SortOutlined from "@mui/icons-material/SortOutlined";
import { Divider, IconButton, InputAdornment, Popper, Stack, TextField, Typography } from "@mui/material";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { ClearIcon } from "@mui/x-date-pickers";
import { useState } from "react";
import CheckIcon from '@mui/icons-material/Check';
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next';
const SearchComponent = ({createdate, handleSortChange, handleSearchChange, titleNewest = 'newest', titleOldest = 'oldest'}) => {
    const { t } = useTranslation();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    const searchChange = (event) => {
        setSearchTerm(event.target.value);
        handleSearchChange(event.target.value);
    }

    const handleClose = () => {
        setDrawerOpen(false);
    };

    return <>
    <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} style={{width: '100%'}}>
                <TextField
                    fullWidth
                    data-testid="search-input"
                    placeholder={t('search')}
                    value={searchTerm}
                    onChange={searchChange}
                    slotProps={{
                        input: {
                            startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
                            endAdornment: <InputAdornment position="end">{searchTerm && searchTerm.length > 0 && <ClearIcon onClick={() => {
                                setSearchTerm('');
                                searchChange({ target: { value: '' } });
                            }} />} </InputAdornment>,
                        }
                    }}
                />
                <IconButton data-testid="sort-button" aria-label={t('sortBy', 'Sort by')} style={{ backgroundColor: drawerOpen ? "#FFFFFF20" : "transparent" }} onClick={(event) => {
                    setDrawerOpen(!drawerOpen);
                    setAnchorEl(event.currentTarget);
                }}>
                    <SortOutlined />
                </IconButton>


            <Popper
                placement="bottom-end"
                open={drawerOpen}
                disablePortal={false}
                anchorEl={anchorEl}
                modifiers={[
                    {
                        name: 'flip',
                        enabled: true,
                        options: {
                            altBoundary: true,
                            rootBoundary: 'document',
                            padding: 8,
                        },
                    },
                    {
                        name: 'preventOverflow',
                        enabled: true,
                        options: {
                            altAxis: true,
                            altBoundary: true,
                            tether: true,
                            rootBoundary: 'document',
                            padding: 8,
                        },
                    },
                    {
                        name: 'arrow',
                        enabled: false,

                    },
                ]}
            >
                <ClickAwayListener onClickAway={handleClose}>
                    <Stack elevation={3} direction="column" spacing={2} style={{
                        backgroundColor: 'rgba(30,35,50,0.98)',
                        backdropFilter: 'blur(16px)',
                        border: '1px solid rgba(255,255,255,0.1)',
                        padding: '20px',
                        borderRadius: '20px',
                        marginTop: '10px',
                        width: '280px'
                    }}>
                        <Typography style={{ color: 'rgba(255,255,255,0.6)', fontSize: '16px' }}>{t('sortBy')}</Typography>
                        <Stack data-testid="sort-newest" role="button" tabIndex={0} style={{ marginLeft: '20px', cursor: 'pointer' }} onClick={() => {
                            handleSortChange(searchTerm, "DESCENDING");
                            handleClose();
                        }} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleSortChange(searchTerm, "DESCENDING"); handleClose(); }}} direction="row" justifyContent="start" alignItems="start" spacing={1}>
                            {createdate === "DESCENDING" && <CheckIcon style={{ color: 'white' }} />}
                            <Typography variant="body1" style={{ color: 'white' }}>{t(titleNewest)}</Typography>
                        </Stack>
                        <Divider style={{ backgroundColor: 'rgba(255,255,255,0.1)' }} orientation="horizontal" />
                        <Stack data-testid="sort-oldest" role="button" tabIndex={0} style={{ marginLeft: '20px', cursor: 'pointer' }} onClick={() => {
                            handleSortChange(searchTerm, "ASCENDING");
                            handleClose();
                        }} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleSortChange(searchTerm, "ASCENDING"); handleClose(); }}} direction="row" justifyContent="start" alignItems="start" spacing={1}>
                            {createdate === "ASCENDING" && <CheckIcon style={{ color: 'white' }} />}
                            <Typography variant="body1" style={{ color: 'white' }}>{t(titleOldest)}</Typography>
                        </Stack>
                    </Stack>
                </ClickAwayListener>
            </Popper>
            </Stack>
    </>
}

export default SearchComponent;
